import defaultTheme from 'tailwindcss/defaultTheme';
const colors = {
    colors: {
        ...defaultTheme.colors,
        error: '#AD2216',
        background: {
            DEFAULT: 'rgb(var(--background-rgb) / <alpha-value>)'
        },
        black: 'rgb(var(--color-black) / <alpha-value>)',
        white: 'rgb(var(--color-white) / <alpha-value>)',
        gray: {
            50: 'rgb(var(--color-gray-50) / <alpha-value>)',
            90: 'rgb(var(--color-gray-90) / <alpha-value>)',
            100: 'rgb(var(--color-gray-100) / <alpha-value>)',
            110: 'rgb(var(--color-gray-110) / <alpha-value>)',
            120: 'rgb(var(--color-gray-120) / <alpha-value>)',
            200: 'rgb(var(--color-gray-200) / <alpha-value>)',
            210: 'rgb(var(--color-gray-210) / <alpha-value>)',
            230: 'rgb(var(--color-gray-230) / <alpha-value>)',
            250: 'rgb(var(--color-gray-250) / <alpha-value>)',
            300: 'rgb(var(--color-gray-300) / <alpha-value>)',
            350: 'rgb(var(--color-gray-350) / <alpha-value>)',
            400: 'rgb(var(--color-gray-400) / <alpha-value>)',
            500: 'rgb(var(--color-gray-500) / <alpha-value>)',
            700: 'rgb(var(--color-gray-700) / <alpha-value>)',
            950: 'rgb(var(--color-gray-950) / <alpha-value>)'
        },
        guide: {
            REGION_AND_APPELLATION: '#FF9228',
            DESTINATION: '#FF9228',
            WINE_ACCORD: '#EB6B6B',
            OUR_FAVORITE: '#EB6B6B',
            WINE_CULTURE: '#EABE08',
            GASTRONOMY: '#EABE08',
            EVENT: '#52BD79',
            CONVENIENT: '#0EC3EE'
        },
        info: '#4280FC',
        privilege: {
            DEFAULT: 'rgb(var(--info-rgb) / <alpha-value>)',
            dark: 'rgb(var(--info-dark-rgb) / <alpha-value>)'
        },
        primary: {
            DEFAULT: 'rgb(var(--primary-default-rgb) / <alpha-value>)',
            light: 'rgb(var(--primary-light-rgb) / <alpha-value>)',
            dark: 'rgb(var(--primary-dark-rgb) / <alpha-value>)'
        },
        rating: '#FFAA00',
        text: {
            333: 'rgb(var(--text-333-rgb) / <alpha-value>)',
            666: 'rgb(var(--text-666-rgb) / <alpha-value>)',
            999: 'rgb(var(--text-999-rgb) / <alpha-value>)',
            title: 'rgb(var(--title-rgb) / <alpha-value>)'
        },
        wine: {
            RED: '#8C1B2D',
            ROSE: '#E37A84',
            WHITE: '#D1C581'
        }
    }
};
export default colors;
